import { JemmaFacilityCreateResponseData } from './facility/jemma-facility.types';
import { JemmaOrganizationCreateResponseData } from './organization/jemma-organization.types';
import { JemmaStudyCreateResponseData } from './study/jemma-study.types';

/** The four peer tabs a user can switch between; `organization`, `facility` and `study` have working forms in this POC — `investigator` is a placeholder only. */
export type EntityTab = 'organization' | 'facility' | 'study' | 'investigator';

/** Every tab, in the fixed order the widget always displays them in. */
export const ENTITY_TABS: readonly EntityTab[] = ['organization', 'facility', 'study', 'investigator'];

export const ENTITY_TAB_LABELS: Record<EntityTab, string> = {
    organization: 'Organization',
    facility: 'Facility',
    study: 'Study',
    investigator: 'Investigator'
};

/** `form` shows the tabbed forms; `success` replaces them with the mock creation result. */
export type WidgetView = 'form' | 'success';

/**
 * Discriminated union for `CreateEntityElementComponent.result` — exactly one entity is ever
 * created per submission, and this shape lets both the template (`@switch (wizard.result()?.kind)`) and
 * `addAnother()` narrow on `kind` instead of checking which of several optional properties happens
 * to be set.
 */
export type EntityCreationResult =
    | { kind: 'organization'; data: JemmaOrganizationCreateResponseData }
    | { kind: 'facility'; data: JemmaFacilityCreateResponseData }
    | { kind: 'study'; data: JemmaStudyCreateResponseData };

/** Custom events dispatched on the host element (bubbles + composed so hosts can listen from outside the shadow root). */
export const CREATE_ENTITY_EVENTS = {
    created: 'entity-created',
    cancelled: 'entity-cancelled',
    closed: 'entity-closed',
    failed: 'entity-failed'
} as const;

/** Shown (and reported via `CREATE_ENTITY_EVENTS.failed`) when the host hasn't supplied a usable `accessToken`/`eventSource`. */
export const NOT_CONFIGURED_MESSAGE = 'The widget is not configured. Provide a valid access token and event source.';
